import AOS from 'aos';

const defaultOptions = {
  duration: 800,
  offset: 0,
};

const initAOS = () => AOS.init(defaultOptions);

export default initAOS;
